module.exports = __webpack_public_path__ + "img/schedule.4caf60d6.png";